import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { CryptoService } from './crypto.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CryptoService } from './crypto.service';

@Injectable({
  providedIn: 'root'
})
export class DataDecryptionIntercaptorService implements HttpInterceptor {

  constructor(
    private _CryptoService: CryptoService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Manipulate request data here if needed
    // For example, adding headers, modifying body, etc.

    const urlToSkip = ['common/upload-image', 'account/uploadAffiliateDocumentImage', 'account/uploadAffiliateDocument'];


    // Skip encryption if the request URL includes any of the specified paths
    if (urlToSkip.some(path => request.url.includes(path))) {
      return next.handle(request);
    }



    // Clone the request and manipulate it if needed
    const modifiedRequest = request.clone({
      // Example: Adding a custom header
      setHeaders: {
        'X-Custom-Header': 'custom-value'
      }
    });

    return next.handle(modifiedRequest).pipe(
      map((event: HttpEvent<any>) => {
        // Manipulate response data here if needed
        // For example, modifying response body

        if (event instanceof HttpResponse) {
          console.log("event?.body", event);
          // Modify the response body here 
          if (event?.body) {



            if (event?.body?.obfuscated) {
              this._CryptoService.secretKey = this._CryptoService.getKey(event?.body?.obfuscated);
              const data = this._CryptoService.getData(event?.body?.obfuscated);
              console.log("---===-->", event.url, JSON.parse(JSON.parse(this._CryptoService.decryptData(data, this._CryptoService.secretKey))));
              return event.clone({ body: JSON.parse(JSON.parse(this._CryptoService.decryptData(data, this._CryptoService.secretKey))) });
            }
          }
          // Example: Adding a property to each item in the response array 
        }

        return event;
      })
    );
  }

}
